import { useContext, useEffect, useState } from "react";
import BubbleChart from "./BubbleChart";
import Radar from "./Radar";
import { data } from "./data/data";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { RadarContext } from "./RadarContextProvider";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Wrapper = styled.div`
  position: relative;
  padding-bottom: 100px;
  overflow: hidden;
  z-index: 2;
  width: 80vw;
  @media screen and (max-width: 1000px) {
    width: 100%;
  }
  .mobile {
    text-align: left;
    margin: 20px;
    .tech {
      font-size: 18px;
      padding-bottom: 5px;
      font-family: poppins, sans-serif;
      font-weight: 300;
    }
  }
  @media screen and (min-width: 1000px) {
    .mobile {
      display: none;
      text-align: left;
    }
  }
`;

const OutterWrapper = styled.div`
  display: inline-block;
  z-index: 2;
  @media screen and (min-width: 1000px) {
    .mobile {
      width: 100%;
    }
  }
`;

const Title = styled.div`
  font-size: 26px;
  font-family: "DM Serif Display", serif;
  cursor: pointer;
  user-select: none;
`;
const Description = styled.p`
  font-size: 18px;
  text-align: left;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  line-height: 1.5;
  font-family: "DM Sans", serif;
`;

const TechStack = () => {
  const { setCategory } = useContext<any>(RadarContext);
  const navigate = useNavigate();
  const [activeBubble, setActiveBubble] = useState<{
    chartId: string;
    index: number;
  } | null>(null);

  // Only scroll to top on initial mount, not on every render
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []); // Empty dependency array - only run once on mount

  const handleTitleClick = (name: string) => {
    setCategory(name);
    navigate(name.toLocaleLowerCase().replace("/", "").replace(" ", ""));
  };

  return (
    <OutterWrapper>
      <Wrapper>
        <Radar />
        <div className="mobile">
          {data.map(({ name, data, description }, idx: number) => {
            const bubbleData = data.preferred
              .map((item) => ({ ...item, occurence: 150 }))
              .concat(
                data.learning.map((item) => ({ ...item, occurence: 30 }))
              );

            return (
              <div style={{ marginBottom: 20 }} key={`${name}-${idx}`}>
                <Title
                  onClick={() => handleTitleClick(name)}
                  onTouchStart={(e) => e.preventDefault()} // Prevent scrolling on touch
                >
                  {name}
                  <ArrowForwardIcon
                    fontSize="small"
                    style={{ marginLeft: 10 }}
                  />
                </Title>
                <Description>{description}</Description>
                <BubbleChart
                  chartId={`chart-${idx}`}
                  data={bubbleData}
                  activeBubble={activeBubble}
                  setActiveBubble={setActiveBubble}
                />
              </div>
            );
          })}
        </div>
      </Wrapper>
    </OutterWrapper>
  );
};

export default TechStack;
